"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createFilteredStreamTransform", {
    enumerable: true,
    get: function() {
        return createFilteredStreamTransform;
    }
});
const _stream = require("stream");
const _stdioStreamMarkers = require("./stdioStreamMarkers.js");
function createFilteredStreamTransform() {
    const transform = new _stream.Transform({
        transform (chunk, _encoding, callback) {
            let str = chunk.toString();
            if (str.includes(_stdioStreamMarkers.START_MARKER_PREFIX)) {
                str = str.replace(new RegExp(_stdioStreamMarkers.START_MARKER_PREFIX + "[0-9a-z]{64}\n"), "");
            }
            if (str.includes(_stdioStreamMarkers.END_MARKER_PREFIX)) {
                str = str.replace(new RegExp(_stdioStreamMarkers.END_MARKER_PREFIX + "[0-9a-z]{64}\n"), "");
            }
            callback(null, str);
        }
    });
    return transform;
}
